<div class="p-l-content">
  <div class="p-grid section-div">
    <div class="p-col-4 p-b-0" *ngIf="isUpdate()">
      <label class="section-header-label">{{ 'TRACK_CHANGES.ACCORDION_CONTENT.BASIC' | translate}}</label>
    </div>
    <div class="p-col-6 p-b-0" *ngIf="!isUpdate()">
      <label class="section-header-label">{{ 'TRACK_CHANGES.ACCORDION_CONTENT.BASIC' | translate}}</label>
    </div>
    <div class="p-col-4 p-b-0" *ngIf="isUpdate()">
      <label>{{ 'TRACK_CHANGES.ACCORDION_CONTENT.OLD_VALUES' | translate}}</label>
    </div>
    <div class="p-col-4 p-b-0" *ngIf="isUpdate()">
      <label>{{ 'TRACK_CHANGES.ACCORDION_CONTENT.NEW_VALUES' | translate}}</label>
    </div>
    <div class="p-col-6 p-b-0" *ngIf="isCreate()">
      <label>{{ 'TRACK_CHANGES.ACCORDION_CONTENT.NEW_VALUES' | translate}}</label>
    </div>
    <div class="p-col-6 p-b-0" *ngIf="isDelete()">
      <label>{{ 'TRACK_CHANGES.ACCORDION_CONTENT.OLD_VALUES' | translate}}</label>
    </div>
  </div>

  <div *ngIf="isOrganization() && trackChangeDetail!==undefined">
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="name"
                  translation="TRACK_CHANGES.ATTRIBUTES.NAME"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="nameFr"
                  translation="TRACK_CHANGES.ATTRIBUTES.NAME_FR"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="secondaryName"
                  translation="TRACK_CHANGES.ATTRIBUTES.SECONDARY_NAME"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="secondaryNameFr"
                  translation="TRACK_CHANGES.ATTRIBUTES.SECONDARY_NAME_FR"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="organizationType.name"
                  translation="TRACK_CHANGES.ATTRIBUTES.ORGANIZATION_TYPE"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="organizationSubtype.name"
                  translation="TRACK_CHANGES.ATTRIBUTES.ORGANIZATION_SUB_TYPE"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="parentOrganization.name"
                  translation="TRACK_CHANGES.ATTRIBUTES.PARENT_ORGANIZATION"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="country.name"
                  translation="TRACK_CHANGES.ATTRIBUTES.COUNTRY"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="sfhAssessmentDate"
                  translation="TRACK_CHANGES.ATTRIBUTES.SAFE_FROM_HARM_ASSESSMENT" [dateFlag]="true"
    ></wsd-row-diff>
  </div>

  <div *ngIf="!isOrganization() && trackChangeDetail!==undefined">
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="title"
                  translation="TRACK_CHANGES.ATTRIBUTES.TITLE"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="firstName"
                  translation="TRACK_CHANGES.ATTRIBUTES.FIRST_NAME"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="middleName"
                  translation="TRACK_CHANGES.ATTRIBUTES.MIDDLE_NAME"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="lastName"
                  translation="TRACK_CHANGES.ATTRIBUTES.LAST_NAME"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="initials"
                  translation="TRACK_CHANGES.ATTRIBUTES.INITIALS"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="honours"
                  translation="TRACK_CHANGES.ATTRIBUTES.HONOURS"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="suffix"
                  translation="TRACK_CHANGES.ATTRIBUTES.SUFFIX"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="gender"
                  translation="TRACK_CHANGES.ATTRIBUTES.GENDER"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="organization.name"
                  translation="TRACK_CHANGES.ATTRIBUTES.PERSON_ORGANIZATION"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="country.name"
                  translation="TRACK_CHANGES.ATTRIBUTES.PERSON_COUNTRY"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="region.name"
                  translation="TRACK_CHANGES.ATTRIBUTES.REGION"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="officialLanguage.name"
                  translation="TRACK_CHANGES.ATTRIBUTES.OFFICIAL_LANGUAGE"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="workingLanguage.name"
                  translation="TRACK_CHANGES.ATTRIBUTES.WORKING_LANGUAGE"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="expertiseAreas"
                  translation="TRACK_CHANGES.ATTRIBUTES.EXPERTISE_AREAS" [listFlag]="true"
                  listAtt="name"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="comment"
                  translation="TRACK_CHANGES.ATTRIBUTES.COMMENT"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="employee"
                  translation="TRACK_CHANGES.ATTRIBUTES.EMPLOYEE"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="consent"
                  translation="TRACK_CHANGES.ATTRIBUTES.CONSENT"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="consentGivenDate"
                  translation="TRACK_CHANGES.ATTRIBUTES.CONSENT_DATE" [dateFlag]="true"></wsd-row-diff>
  </div>

  <div class="p-grid section-div" *ngIf="isOrganization() && showAppointeesSectionFlag">
    <div class="p-col-4 p-b-0">
      <label class="section-header-label">{{ 'TRACK_CHANGES.ACCORDION_CONTENT.APPOINTEES' | translate}}</label>
    </div>
  </div>
  <wsd-list-diff
    *ngIf="isOrganization() && trackChangeDetail!==undefined"
    [data]="trackChangeDetail"
    [update]="isUpdate()"
    listAttribute="appointees"
    headerAttribute="standardTitle.name"
    [subsectionHeaderArr]="['consultant.firstName','consultant.lastName']"
    [attributesDisplayed]="[
  {translation: 'TRACK_CHANGES.DATA_ATTRIBUTES.DIRECTORY_TITLE', attributePath: 'directoryTitle', attributeValue: ''},
  {translation: 'TRACK_CHANGES.DATA_ATTRIBUTES.DIRECTORY_SECOND_TITLE', attributePath: 'directorySecondTitle', attributeValue: '' },
  {translation: 'TRACK_CHANGES.DATA_ATTRIBUTES.EMAIL', attributePath: 'email', attributeValue: '' },
  {translation: 'TRACK_CHANGES.DATA_ATTRIBUTES.BUSINESS_CARD_VISIBLE', attributePath: 'businessCardVisible', attributeValue: '' },
  {translation: 'TRACK_CHANGES.DATA_ATTRIBUTES.OFFICIAL', attributePath: 'official', attributeValue: '' }
  ]"
    (onVisibilityChange)="setShowAppointeesSectionFlag()"
  ></wsd-list-diff>

  <div class="p-grid section-div" *ngIf="showContactsSectionFlag">
    <div class="p-col-4 p-b-0">
      <label class="section-header-label">{{ 'TRACK_CHANGES.ACCORDION_CONTENT.CONTACTS' | translate}}</label>
    </div>
  </div>
  <wsd-list-diff
    *ngIf="trackChangeDetail!==undefined"
    [data]="trackChangeDetail"
    [update]="isUpdate()"
    listAttribute="contacts"
    headerAttribute="type"
    [attributesDisplayed]="[
  {translation: 'TRACK_CHANGES.DATA_ATTRIBUTES.CONTACT_VALUE', attributePath: 'value', attributeValue: '' },
  {translation: 'TRACK_CHANGES.DATA_ATTRIBUTES.PREFERRED', attributePath: 'preferred', attributeValue: '' },
  {translation: 'TRACK_CHANGES.DATA_ATTRIBUTES.VISIBLE_IN_DIRECTORY', attributePath: 'visibleInDirectory', attributeValue: '' }
]"
    (onVisibilityChange)="setShowContactsSectionFlag()"
  ></wsd-list-diff>

  <div class="p-grid section-div" *ngIf="isOrganization() && showAddressSectionFlag">
    <div class="p-col-4 p-b-0">
      <label class="section-header-label">{{ 'TRACK_CHANGES.ACCORDION_CONTENT.ADDRESS' | translate}}</label>
    </div>
  </div>
  <wsd-list-diff
    *ngIf="isOrganization() && trackChangeDetail!==undefined"
    [data]="trackChangeDetail"
    [update]="isUpdate()"
    listAttribute="addresses"
    headerAttribute="locationType"
    [attributesDisplayed]="[
  {translation: 'TRACK_CHANGES.DATA_ATTRIBUTES.ADDRESS1', attributePath: 'address1', attributeValue: '' },
{translation: 'TRACK_CHANGES.DATA_ATTRIBUTES.ADDRESS2', attributePath: 'address2', attributeValue: '' },
{translation: 'TRACK_CHANGES.DATA_ATTRIBUTES.ADDRESS3', attributePath: 'address3', attributeValue: '' },
{translation: 'TRACK_CHANGES.DATA_ATTRIBUTES.ADDRESS4', attributePath: 'address4', attributeValue: '' },
{translation: 'TRACK_CHANGES.DATA_ATTRIBUTES.ZIP', attributePath: 'zip', attributeValue: '' },
{translation: 'TRACK_CHANGES.DATA_ATTRIBUTES.TOWN_CITY', attributePath: 'townCity', attributeValue: '' },
{translation: 'TRACK_CHANGES.DATA_ATTRIBUTES.COUNTRY_NAME', attributePath: 'country.name', attributeValue: '' }
]"
    (onVisibilityChange)="setShowAddressSectionFlag()"
  ></wsd-list-diff>

  <div class="p-grid section-div" *ngIf="!isOrganization() && showAppointmentsSectionFlag">
    <div class="p-col-4 p-b-0">
      <label class="section-header-label">{{ 'TRACK_CHANGES.ACCORDION_CONTENT.APPOINTMENTS' | translate}}</label>
    </div>
  </div>
  <wsd-list-diff
    *ngIf="!isOrganization() && trackChangeDetail!==undefined"
    [data]="trackChangeDetail"
    [update]="isUpdate()"
    listAttribute="appointments"
    [subsectionHeaderArr]="['organization.name']"
    headerAttribute="standardTitle.name"
    [attributesDisplayed]="[
  {translation: 'TRACK_CHANGES.DATA_ATTRIBUTES.DIRECTORY_TITLE', attributePath: 'directoryTitle', attributeValue: ''},
  {translation: 'TRACK_CHANGES.DATA_ATTRIBUTES.DIRECTORY_SECOND_TITLE', attributePath: 'directorySecondTitle', attributeValue: '' },
  {translation: 'TRACK_CHANGES.DATA_ATTRIBUTES.EMAIL', attributePath: 'email', attributeValue: '' },
  {translation: 'TRACK_CHANGES.DATA_ATTRIBUTES.BUSINESS_CARD_VISIBLE', attributePath: 'businessCardVisible', attributeValue: '' },
  {translation: 'TRACK_CHANGES.DATA_ATTRIBUTES.OFFICIAL', attributePath: 'official', attributeValue: '' }]"
    (onVisibilityChange)="setShowAppointmentsSectionFlag()"
  ></wsd-list-diff>

  <div class="p-grid section-div" *ngIf="isOrganization() && showMembershipSectionFlag">
    <div class="p-col-4 p-b-0">
      <label class="section-header-label">{{ 'TRACK_CHANGES.ACCORDION_CONTENT.MEMBERSHIP' | translate}}</label>
    </div>
  </div>
  <div *ngIf="isOrganization() && trackChangeDetail!==undefined">
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="feeCategory"
                  translation="TRACK_CHANGES.ATTRIBUTES.FEE_CATEGORY"
                  (onVisibilityChange)="setShowMembershipSectionFlag()"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="eventCategory"
                  translation="TRACK_CHANGES.ATTRIBUTES.EVENT_CATEGORY"
                  (onVisibilityChange)="setShowMembershipSectionFlag()"></wsd-row-diff>
  </div>


  <div class="p-grid section-div" *ngIf="isOrganization() && showTechnicalSectionFlag">
    <div class="p-col-4 p-b-0">
      <label
        class="section-header-label">{{ 'TRACK_CHANGES.ACCORDION_CONTENT.TECHNICAL_INFORMATION' | translate}}</label>
    </div>
  </div>
  <div *ngIf="isOrganization() && trackChangeDetail!==undefined">
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="acronym"
                  translation="TRACK_CHANGES.ATTRIBUTES.ACRONYM"
                  (onVisibilityChange)="setShowTechnicalFlag()"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="suspensionStatus"
                  translation="TRACK_CHANGES.ATTRIBUTES.SUSPENSION_STATUS"
                  (onVisibilityChange)="setShowTechnicalFlag()"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="suspensionInformation"
                  translation="TRACK_CHANGES.ATTRIBUTES.SUSPENSION_INFORMATION"
                  (onVisibilityChange)="setShowTechnicalFlag()"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="confidentialInformation"
                  translation="TRACK_CHANGES.ATTRIBUTES.CONFIDENTIAL_INFORMATION"
                  (onVisibilityChange)="setShowTechnicalFlag()"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="order"
                  translation="TRACK_CHANGES.ATTRIBUTES.ORDER"
                  (onVisibilityChange)="setShowTechnicalFlag()"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="globalLanguage.name"
                  translation="TRACK_CHANGES.ATTRIBUTES.TI_GLOBAL_LANGUAGE"
                  (onVisibilityChange)="setShowTechnicalFlag()"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="workingLanguage.name"
                  translation="TRACK_CHANGES.ATTRIBUTES.TI_WORKING_LANGUAGE"
                  (onVisibilityChange)="setShowTechnicalFlag()"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="currency.isoCode"
                  translation="TRACK_CHANGES.ATTRIBUTES.CURRENCY"
                  (onVisibilityChange)="setShowTechnicalFlag()"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="notes"
                  translation="TRACK_CHANGES.ATTRIBUTES.NOTES"
                  (onVisibilityChange)="setShowTechnicalFlag()"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="foundingDate"
                  translation="TRACK_CHANGES.ATTRIBUTES.FOUNDING_DATE" [dateFlag]="true"
                  (onVisibilityChange)="setShowTechnicalFlag()"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="federation"
                  translation="TRACK_CHANGES.ATTRIBUTES.FEDERATION"
                  (onVisibilityChange)="setShowTechnicalFlag()"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="potentialMember"
                  translation="TRACK_CHANGES.ATTRIBUTES.POTENTIAL_MEMBER"
                  (onVisibilityChange)="setShowTechnicalFlag()"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="wagggsMember"
                  translation="TRACK_CHANGES.ATTRIBUTES.WAGGGS_MEMBER"
                  (onVisibilityChange)="setShowTechnicalFlag()"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="wosmMembershipYear"
                  translation="TRACK_CHANGES.ATTRIBUTES.WOSM_MEMBERSHIP_YEAR"
                  (onVisibilityChange)="setShowTechnicalFlag()"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="wosmMembership"
                  translation="TRACK_CHANGES.ATTRIBUTES.WOSM_MEMBERSHIP"
                  (onVisibilityChange)="setShowTechnicalFlag()"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="pastWosmEvents"
                  translation="TRACK_CHANGES.ATTRIBUTES.PAST_WOSM_EVENTS"
                  (onVisibilityChange)="setShowTechnicalFlag()"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="summaryList.[0].description"
                  translation="TRACK_CHANGES.ATTRIBUTES.NSO_SUMMARY_LIST"
                  (onVisibilityChange)="setShowTechnicalFlag()"></wsd-row-diff>
    <wsd-row-diff [update]="isUpdate()" [data]="trackChangeDetail" attribute="visibleInDirectory"
                  translation="TRACK_CHANGES.ATTRIBUTES.VISIBLE_IN_DIRECTORY"
                  (onVisibilityChange)="setShowTechnicalFlag()"></wsd-row-diff>
  </div>


  <div class="p-grid"
       *ngIf="isUpdate() && isOrganization() && trackChangeDetail!==undefined && detectedSimpleArrayChange('policyDocuments')">
    <div class="p-col-12 change-info-div" style="text-align: center; ">
      {{"TRACK_CHANGES.ACCORDION_CONTENT.POLICY_TEXT" | translate}}
    </div>
  </div>

  <div class="p-grid"
       *ngIf="isUpdate() && isOrganization() && trackChangeDetail!==undefined && detectedSimpleArrayChange('interactions')">
    <div class="p-col-12 change-info-div" style="text-align: center; ">
      {{"TRACK_CHANGES.ACCORDION_CONTENT.INTERACTIONS_TEXT"| translate}}
    </div>
  </div>

  <div class="p-grid"
       *ngIf="isUpdate() && isOrganization() && trackChangeDetail!==undefined &&  detectedSimpleArrayChange('fileInfo')">
    <div class="p-col-12 change-info-div" style="text-align: center; ">
      {{"TRACK_CHANGES.ACCORDION_CONTENT.REPORTING_TEXT"| translate}}
    </div>
  </div>
</div>
